import React from "react";

import { Divider, Space, Switch, Select } from "antd";

const Filters = (props) => {
    const { filters } = props;
    const isActive = filters ? filters.active == 1 : false;

    const clientId = filters ? (filters.clientId ? parseInt(filters.clientId) : undefined) : undefined;
    const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return (
        <>
            <Space size="small">
                <Switch
                    checked={isActive}
                    size="small"
                    onChange={(bool) => props.onUpdateFilters({ active: bool ? 1 : 0 })}
                />{" "}
                Actives
            </Space>
            <br />
            <br />
            <Space size="small">
                Filters:
                <Select
                    placeholder="Client"
                    allowClear
                    name="client"
                    size="small"
                    showSearch
                    options={props.clients}
                    filterOption={_filter}
                    style={{ minWidth: "150px" }}
                    value={clientId}
                    onChange={(e) => {
                        props.onUpdateFilters({ clientId: e ? e : undefined });
                    }}
                />
            </Space>
        </>
    );
};

export default Filters;
